import { type HTMLAttributes, type ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

// v7 Forest Glass card — 캔버스 위에 살짝 떠 있는 글래스 표면
export function Card({ children, className = '', ...rest }: CardProps) {
  return (
    <div
      className={`rounded-[22px] border border-surface-border/70 bg-surface/60 backdrop-blur-sm p-4 ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
